import script from "./SurveyVoteEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./SurveyVoteEditor.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__